import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.Save.IRequest;
type Response = Api.Core.ClaimJob.Save.IResponse;
type Headers = Api.Core.ClaimJob.Save.IHeaders;
const url = '/api/Claims/ClaimJob';
export default async function claimJobSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
